module.exports = __webpack_public_path__ + "static/media/hat.97f60952.png";